import React from 'react'
import styled from 'styled-components'
import { FileField } from './FieldRenderer'

const hasFile = file => !!(file && typeof file === 'object' && (file.fileId || file.file_id || file._pending || file._offlineFileId || file._offline_file_id))

const FileList = ({ files, onChange, readOnly, taskId, photosOnly = false, emptyText = 'Nothing attached yet.' }) => {
  const list = (Array.isArray(files) ? files : []).filter(hasFile)
  const field = photosOnly
    ? { key: 'photo', fileAcceptMode: 'photos_only', acceptedMimeTypes: ['image/*'], maxFileSizeMb: 10 }
    : { key: 'attachment', fileAcceptMode: 'files_and_photos', maxFileSizeMb: 25 }

  const replaceAt = (index, value) => {
    const next = [...list]
    if (value) next[index] = value
    else next.splice(index, 1)
    onChange(next)
  }

  if (readOnly && list.length === 0) return <Empty>{emptyText}</Empty>

  return (
    <Wrap>
      {list.map((file, index) => (
        <FileField
          key={file.fileId || file.file_id || file._offlineFileId || file._offline_file_id || index}
          field={field}
          value={file}
          onChange={value => replaceAt(index, value)}
          readOnly={readOnly}
          taskId={taskId}
        />
      ))}
      {!readOnly && (
        <FileField
          key={`new-${list.length}`}
          field={field}
          value={null}
          onChange={value => value && onChange([...list, value])}
          readOnly={false}
          taskId={taskId}
        />
      )}
    </Wrap>
  )
}

export default FileList

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

const Empty = styled.p`
  margin: 0;
  font-size: 14px;
  color: #667085;
`
